// extracted by mini-css-extract-plugin
export var container = "_u3-0";
export var table = "_u3-2";
export var tableWrapper = "_u3-1";